import { combineReducers } from 'redux';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import projectsReducer from './projects/projectsSlice';
import organizationReducer from './organizations/organizationSlice';

const rootReducers = combineReducers({
  auth: authReducer,
  ChangeLayoutMode,
  projects: projectsReducer,
  organization: organizationReducer,
});

export type RootState = ReturnType<typeof rootReducers>;
export default rootReducers;